import { IUser } from "../../../Models/IUser";
import { IBaseAction } from "../Actions/BaseAction";

export type GetUserInitAction  = IBaseAction<null>;
export type GetUserSuccessAction  = IBaseAction<IUser>;
export type GetUserFailureAction  = IBaseAction<string>;
export type SetShowActiveUsersAction  = IBaseAction<boolean>;
export type GetAllUsersInitAction  = IBaseAction<null>;
export type GetAllUsersSuccessAction  = IBaseAction<IUser[]>;
export type GetAllUsersFailureAction  = IBaseAction<string>;
export type SetLoadingAllUsersAction  = IBaseAction<boolean>;

export type UserActionType =
    GetUserInitAction
    | GetUserSuccessAction
    | GetUserFailureAction
    | SetShowActiveUsersAction
    | GetAllUsersInitAction
    | GetAllUsersSuccessAction
    | GetAllUsersFailureAction
    | SetLoadingAllUsersAction;

export const GET_USER_INIT = "GET_USER_INIT";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";
export const SET_SHOW_ACTIVE_USERS = "SET_SHOW_ACTIVE_USERS";
export const GET_ALL_USERS_INIT = "GET_ALL_USERS_INIT";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILURE = "GET_ALL_USERS_FAILURE";
export const SET_LOADING_ALL_USERS = "SET_LOADING_ALL_USERS";